<div class="error-msg" [class.hide]="_hide">{{_text}}</div>